<template>
    <div class="bg-grey-100 p-5 flex flex-wrap">

        <label class="checkbox mb-5">
            <span class="checkbox__input">
                <input type="checkbox"
                    v-model="portalAccess"
                    :checked="portalAccess">

                <span class="checkbox__control">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path fill="none" stroke="#00ce7d" stroke-width="3" d="M1.73 12.91l6.37 6.37L22.79 4.59" /></svg>
                </span>
            </span>
            <span class="radio__label">Grant login access to the MySAU Portal</span>
        </label>


        <div class="w-100 mb-5">
            <h3 class="text-lg font-semibold">Role</h3>
            <div class="flex flex-wrap">
                <div v-for="(role, index) in roles" :key="`${role.value}-${index}`"
                    class="w-1/2 md:w-1/4"
                >
                    <button @click="selectRole(role.value)" class="p-3 px-6 d-block mx-auto rounded border-2 focus:outline-none border-solid" :class="[{ 'border-green bg-green-100' : matchedRole == role.value }, 'border-opacity-0']">
                        <i :class="role.icon" class="d-block text-4xl"></i>
                        {{ role.value | CapitaliseFirst }}
                    </button>
                </div>
            </div>
        </div>

        <div class="w-full md:w-1/2">
            <h3 class="text-lg font-semibold">Permissions</h3>
            <div v-for="(permission, index) in permissions" :key="`${permission.value}-${index}`">
                <label class="checkbox">
                    <span class="checkbox__input">
                        <input type="checkbox"
                            v-model="permission.enabled"
                            :checked="permission.enabled">

                        <span class="checkbox__control">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <path fill="none" stroke="#00ce7d" stroke-width="3" d="M1.73 12.91l6.37 6.37L22.79 4.59" /></svg>
                        </span>
                    </span>
                    <span class="radio__label">{{ permission.label}}</span>
                </label>
            </div>
        </div>

        <div class="w-full md:w-1/2">
            <h3 class="text-lg font-semibold">Subscriptions</h3>
            <div v-for="(subscription, index) in subscriptions" :key="`subscription-${index}`">
                <label class="checkbox">
                    <span class="checkbox__input">
                        <input type="checkbox"
                            v-model="subscription.enabled"
                            :checked="subscription.enabled">
                        <span class="checkbox__control">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <path fill="none" stroke="#00ce7d" stroke-width="3" d="M1.73 12.91l6.37 6.37L22.79 4.59" /></svg>
                        </span>
                    </span>
                    <span class="radio__label">{{ subscription.label }}</span>
                </label>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        settings: {
            type: Object,
        }
    },

    data() {
        return {
            portalAccess: false,
            matchedRole: '',
            roles: [
                { value: 'support', icon: 'fal fa-user-headset' },
                { value: 'billing', icon: 'fal fa-user-tie' },
                { value: 'admin', icon: 'fal fa-user-crown' },
                { value: 'custom', icon: 'fal fa-user-cog' },
            ],
            permissions: [
                {
                    label: 'View Products & Services',
                    value: 'products',
                    enabled: false,
                    roles: ['admin', 'billing', 'support']
                },
                {
                    label: 'View Domains',
                    value: 'domains',
                    enabled: false,
                    roles: ['admin', 'billing', 'support']
                },
                {
                    label: 'View & Open Cases',
                    value: 'tickets',
                    enabled: false,
                    roles: ['admin', 'billing', 'support']
                },
                {
                    label: 'View Emails',
                    value: 'emails',
                    enabled: false,
                    roles: ['admin', 'billing', 'support']
                },
                {
                    label: 'Place New Orders/Upgrades/Cancellations',
                    value: 'orders',
                    enabled: false,
                    roles: ['admin', 'billing']
                },
                {
                    label: 'View & Pay Invoices',
                    value: 'invoices',
                    enabled: false,
                    roles: ['admin', 'billing']
                },
                {
                    label: 'View & Modify Product Passwords',
                    value: 'manageproducts',
                    enabled: false,
                    roles: ['admin', 'admin']
                },
                {
                    label: 'Manage Domain Settings',
                    value: 'managedomains',
                    enabled: false,
                    roles: ['admin', 'admin']
                },
                {
                    label: 'Modify Master Account Profile',
                    value: 'profile',
                    enabled: false,
                    roles: ['admin']
                },
                {
                    label: 'View & Manage Contacts',
                    value: 'contacts',
                    enabled: false,
                    roles: ['admin']
                },
                {
                    label: 'View & Manage Affiliate Account',
                    value: 'affiliates',
                    enabled: false,
                    roles: ['admin']
                },
            ],
            subscriptions: [
                {
                    label: 'Product Emails',
                    value: 'product',
                    enabled: false,
                    roles: ['admin', 'billing', 'support']
                },
                {
                    label: 'Domain Emails',
                    value: 'domain',
                    enabled: false,
                    roles: ['admin', 'billing', 'support']
                },
                {
                    label: 'Support Emails',
                    value: 'support',
                    enabled: false,
                    roles: ['admin', 'billing', 'support']
                },
                {
                    label: 'Invoice Emails',
                    value: 'invoice',
                    enabled: false,
                    roles: ['admin', 'billing']
                },
                {
                    label: 'General and Billing Emails',
                    value: 'general',
                    enabled: false,
                    roles: ['admin', 'billing']
                },
            ]
        }
    },

    mounted() {
        //set the initial state of all the permissions and subscriptions in data() from the props
        this.permissions = this.permissions.map(permission => {
            permission.enabled = this.settings.permissions.includes(permission.value);
            return permission;
        });

        this.subscriptions = this.subscriptions.map(sub => {
            sub.enabled = this.settings.subscriptions.includes(sub.value);
            return sub;
        });

        this.portalAccess = this.settings.loginAccess;

    },

    methods: {

        selectRole(roleName) {
            if(roleName === 'custom') {
                this.matchedRole = 'custom';
                return;
            }

            this.permissions = this.permissions.map(permission => {
                permission.enabled = permission.roles.includes(roleName);
                return permission;
            });

            this.subscriptions = this.subscriptions.map(sub => {
                sub.enabled = sub.roles.includes(roleName);
                return sub;
            })
        },

        handleChange() {
            var allRoles = this.roles.map(role => role.value);

            var goodRoles = [];
            var badRoles = [];

            this.permissions.map(pm => {
                if(pm.enabled) {
                    goodRoles = _.concat(goodRoles, pm.roles);
                    badRoles = _.concat(badRoles, _.difference(allRoles, pm.roles));
                } else {
                    badRoles = _.concat(badRoles, pm.roles);
                }
            })

            var goodSubs = [];
            var badSubs = [];

            this.subscriptions.map(sub => {
                if(sub.enabled) {
                    goodSubs = _.concat(goodSubs, sub.roles);
                    badSubs = _.concat(badSubs, _.difference(allRoles, sub.roles));
                } else {
                    badSubs = _.concat(badSubs, sub.roles);
                }
            })

            const matchedSubs = _.difference(_.uniq(goodSubs), _.uniq(badSubs));
            const matchedRole = _.difference(_.uniq(goodRoles), _.uniq(badRoles));
            const role = _.get(matchedRole, 0, 'custom');

            if(matchedSubs.includes(role)) {
                this.matchedRole = role;
            } else {
                this.matchedRole = 'custom';
            }

            this.$emit('updated', {
                permissions: this.permissions.filter(permission => permission.enabled).map(permission => permission.value),
                subscriptions: this.subscriptions.filter(subscription => subscription.enabled).map(subscription => subscription.value),
                loginAccess: this.portalAccess,
            });
        },
    },

    watch: {
        permissions: {
            handler: 'handleChange',
            deep: true,
            immediate: true,
        },
        subscriptions: {
            handler: 'handleChange',
            deep: true,
            immediate: true,
        },
        portalAccess: {
            handler: 'handleChange',
            immediate: true,
        },
    }
}
</script>

<style lang="scss" scoped>
    .checkbox {
        display: grid;
        grid-template-columns: min-content auto;
        grid-gap: 0.5em;
        &:hover {
            cursor: pointer;
        }
    }

    .checkbox__control {
        display: inline-grid;
        width: 1em;
        height: 1em;
        outline: none;
        border: solid 1px #cacaca;
        border-radius: 3px;

        &:focus {
            outline: none;
        }

        svg {
            transition: transform 0.1s ease-in 25ms;
            transform: scale(0);
            transform-origin: bottom left;
        }
    }

    .checkbox__input {
        display: grid;

        > * {
            grid-area: checkbox;
            cursor:pointer;
        }

        input {
            opacity: 0;
            width: 1em;
            height: 1em;
            outline: none;


            &:focus + .checkbox__control {
                outline: none;
            }

            &:checked + .checkbox__control svg {
                transform: scale(1);
            }

            &:disabled + .checkbox__control {
                color: var(--disabled);
            }
        }
    }

    .border-opacity-0 {
        border-color: rgba(0,0,0,0);
    }

</style>